import { BasvuruFlow, type ProductConfig } from "./BasvuruFlow";
import { InfoNote, SelectField, TextField } from "./shared";

// WEB3 — Sağlık (TSS/ÖSS) teklif-talebi (lead-only, non-vehicle). KARAR-2: the public
// door collects ONLY iletişim + SGK durumu + kapsam/hastane tercihi + AYRI sağlık açık
// rıza (rendered in the KVKK block via config.extraHealthConsent). The health
// DECLARATION (boy/kilo/hastalık/ilaç/ameliyat) is OFFLINE — özel nitelikli veri, the
// advisor collects it later; it is NEVER written to the platform. No vehicle block.

const SGK = [
  { value: "sgkli", label: "SGK’lı (aktif)" },
  { value: "sgksiz", label: "SGK’sız" },
];
const KAPSAM = [
  { value: "yatarak", label: "Yatarak tedavi" },
  { value: "ayakta", label: "Yatarak + Ayakta" },
];

const config: ProductConfig = {
  product: "saglik",
  extraHealthConsent: true,
  intro: {
    eyebrow: "SAĞLIK SİGORTASI · TEKLİF TALEBİ",
    title: "Sağlık teklifi",
    text: "Tamamlayıcı (TSS) veya özel (ÖSS) sağlık sigortası. Kapıda yalnızca iletişim ve kapsam tercihinizi alırız; sağlık beyanını danışmanınız güvenli biçimde toplar.",
  },
  headerTitle: "Sağlık Sigortası",
  infoTitle: "Kapsamınızı belirleyelim",
  infoLead: "SGK durumunuz ve kapsam tercihinizle başlayalım.",
  renderInfo: (ctx) => (
    <>
      <SelectField
        id="sgk"
        label="SGK durumu"
        value={ctx.fields.sgk ?? ""}
        onChange={ctx.setField("sgk")}
        options={SGK}
        error={ctx.errors.sgk}
      />
      <SelectField
        id="kapsam"
        label="Kapsam tercihi"
        value={ctx.fields.kapsam ?? ""}
        onChange={ctx.setField("kapsam")}
        options={KAPSAM}
        error={ctx.errors.kapsam}
      />
      <TextField
        id="hastane"
        label="Tercih ettiğiniz hastane / network (opsiyonel)"
        value={ctx.fields.hastane ?? ""}
        onChange={ctx.setField("hastane")}
        placeholder="Örn. Acıbadem, Memorial"
      />
      <InfoNote>
        Sağlık beyanınız (boy/kilo, geçmiş rahatsızlık, ilaç) bu formda alınmaz — özel nitelikli
        veridir; danışmanınız güvenli biçimde toplar.
      </InfoNote>
    </>
  ),
  validateInfo: (ctx) => {
    const e: Record<string, string> = {};
    if (!(ctx.fields.sgk ?? "").trim()) e.sgk = "SGK durumu zorunlu.";
    if (!(ctx.fields.kapsam ?? "").trim()) e.kapsam = "Kapsam tercihi zorunlu.";
    return e;
  },
  // SAĞLIK §5 door block (webIntakeSchema.health) — SGK durumu, kapsam tercihi and
  // hastane tercihi. declarationOffline flags that the (özel nitelikli) sağlık beyanı is
  // handled offline by the advisor — never the declaration itself.
  // Kapsam now HAS a schema home (coveragePref). It was a REQUIRED field the client then
  // dropped on the floor, so the advisor never received the one answer the form insisted
  // on. It is a coverage preference, not a declaration — non-sensitive capture metadata.
  buildHealth: (fields) => ({
    sgkStatus: ((fields.sgk ?? "").trim() || undefined) as
      | "sgkli"
      | "sgksiz"
      | "bilinmiyor"
      | undefined,
    coveragePref: ((fields.kapsam ?? "").trim() || undefined) as "yatarak" | "ayakta" | undefined,
    hospitalPref: (fields.hastane ?? "").trim() || undefined,
    declarationOffline: true,
  }),
  summary: (fields) => {
    const map: Record<string, string> = {
      yatarak: "Yatarak",
      ayakta: "Yatarak + Ayakta",
    };
    return {
      label: `Sağlık · ${map[fields.kapsam ?? ""] ?? "Kapsam"}`,
      value: "Teklif hazırlanıyor",
    };
  },
};

export function SaglikBasvuru() {
  return <BasvuruFlow config={config} />;
}
